/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {

  const intl = useIntl();
  const role = JSON.parse((localStorage.getItem('kt-auth-react-v') as any) || {})?.data?.role?.role_id;

  return (
    <>   
      {
        (role === 1) && (
          <>
            <SidebarMenuItem
              to='/lead-status'
              title='Lead Status'
              icon='/media/newSvg/lead-status.svg'
              fontIcon='bi-layers'
            />        
            <SidebarMenuItem
              to='/permission'
              title='Permission'
              icon='/media/newSvg/permission.svg'
              fontIcon='bi-layers'
            />
            <SidebarMenuItem
              to='/package'
              title='Package'
              icon='/media/newSvg/package.svg'
              fontIcon='bi-layers'
            />
            <SidebarMenuItemWithSub
              to='/'
              title='SMS Requests'
              fontIcon='bi-archive'
              icon='/media/newSvg/accept-email.svg'
            >
              <SidebarMenuItem to='approved-requests' title='Approved Requests' hasBullet={true} />
              <SidebarMenuItem to='pending-requests' title='Pending Requests' hasBullet={true} />
            </SidebarMenuItemWithSub>
          </>
        )
      }
      {
        (role === 2 || role === 3 || role === 4) && (
          <>
            <SidebarMenuItem
              to='/dashboard'
              icon='/media/newSvg/home.svg'
              title='Home'
              fontIcon='bi-app-indicator'
            />
            <SidebarMenuItem
              to='/contact/mixed'
              icon='/media/newSvg/contact.svg'
              title='Contacts'
              fontIcon='bi-app-indicator'
            />
            <SidebarMenuItem
              to='/contact/companies'
              icon='/media/newSvg/company.svg'
              title='Companies'
              fontIcon='bi-app-indicator'
            />
            <SidebarMenuItem
              to='/contact/new-leads'
              icon='/media/newSvg/lead.svg'
              title='New Leads'
              fontIcon='bi-app-indicator'
            />
            <SidebarMenuItem
              to='/contact/customers'
              icon='/media/newSvg/customer.svg'
              title='Customers'
              fontIcon='bi-app-indicator'
            />
            <SidebarMenuItemWithSub
              to='/'
              title='Marketing'
              fontIcon='bi-archive'
              icon='/media/newSvg/campaign.svg'
            >
              <SidebarMenuItem to='/campaign-dashboard' title='Campaign Dashboard' hasBullet={true} />
              <SidebarMenuItem to='/campaign-list' title='Campaign List' hasBullet={true} />
            </SidebarMenuItemWithSub>
            <SidebarMenuItemWithSub
              to='/'
              title='Settings'
              icon='/media/newSvg/setting.svg'
              fontIcon='bi-layers'
            >
              <SidebarMenuItem to='/settings/profile' title='Profile' hasBullet={true} />
              <SidebarMenuItem to='/settings/users' title='Users' hasBullet={true} />
              <SidebarMenuItem to='/settings/package-subscription' title='Billing' hasBullet={true} />
              <SidebarMenuItem to='/settings/security' title='Security' hasBullet={true} />
              <SidebarMenuItem to='/settings/permissions' title='Permissions' hasBullet={true} />
            </SidebarMenuItemWithSub>
          </>
        )
      }

      {/* <SidebarMenuItem
        to='/dashboard1'
        icon='/media/icons/duotune/art/art002.svg'
        title='Inbox'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItemWithSub
        to='/crafted/accounts12'
        title='Marketing'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/error13'
        title='Report'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen040.svg'
      >
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/dashboard131'
        icon='/media/icons/duotune/art/art002.svg'
        title='Task'
        fontIcon='bi-app-indicator'
      /> */}
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div>  */}
    </>

  )
}

export {SidebarMenuMain}
